import { defineMessages } from 'react-intl';

const messages = defineMessages({
  contentFieldHintText: {
    id: 'boxForm.settings.sidebar.subpanel.upload.contentFieldHintText',
    description: 'Hint text for content field',
    defaultMessage: 'Select Folder',
  },
  contentFieldLabel: {
    id: 'boxForm.settings.sidebar.subpanel.upload.contentFieldLabel',
    description: 'Label for content field',
    defaultMessage: 'Upload to',
  },
});

export default messages;
